import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsAttributeHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Attribute;
    }
}

//# sourceMappingURL=IsAttributeHelper.js.map
